<template>
  <v-card flat outlined class="grey lighten-4">
    <v-card-text>
      <v-row>
        <v-col cols="12">Sträcka</v-col>

        <v-col>
          <v-autocomplete
            :items="stops"
            :disabled="readonly"
            item-value="short_name"
            :item-text="item => `(${item.short_name}) ${item.stop_name}`"
            :filter="
              (item, query) =>
                item.short_name.toLowerCase().includes(query.toLowerCase()) ||
                item.stop_name.toLowerCase().includes(query.toLowerCase())
            "
            outlined
            label="Från plats"
            v-model="from_place"
            hide-details
            ref="routeStartPlace"
          />
        </v-col>
        <v-col>
          <v-autocomplete
            :items="stops"
            item-value="short_name"
            :item-text="item => `(${item.short_name}) ${item.stop_name}`"
            :filter="
              (item, query) =>
                item.short_name.toLowerCase().includes(query.toLowerCase()) ||
                item.stop_name.toLowerCase().includes(query.toLowerCase())
            "
            outlined
            :disabled="readonly"
            ref="routeEndPlace"
            label="Till plats"
            v-model="to_place"
            hide-details
          />
        </v-col>
        <!-- 
          <v-col cols="2" class="mt-2">
            <v-btn
              color="primary"
              icon
              large
              @click="addRoute"
              ref="routeAddBtn"
              @keydown.prevent.enter="goBackToRouteStartPlace"
              :disabled="disableAddButton"
              :tabindex="disableAddButton ? -1 : 0"
            >
              <v-icon>mdi-plus-circle-outline</v-icon>
            </v-btn>
          </v-col> -->
        <!-- 
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col> -->

        <!-- <v-col cols="12">
          <template v-if="eventRoutes.length">
            <v-chip-group active-class="primary--text" column tabindex="-1">
              <v-chip
                v-for="(route, $i) in eventRoutes"
                :key="$i"
                :disabled="readonly"
                tabindex="-1"
                hide-details
              >
                {{ route }}
                <v-icon
                  small
                  right
                  tabindex="-1"
                  v-if="!readonly"
                  @click="removeRoute(route)"
                >
                  mdi-close-circle
                </v-icon>
              </v-chip>
            </v-chip-group>
          </template>
        </v-col> -->
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { sync, get } from 'vuex-pathify'

export default {
  name: 'OdocRoutesInput',

  props: {
    disabled: Boolean,
    readonly: Boolean
  },

  data: () => ({
    from_place: null,
    to_place: null
  }),

  created() {
    this.setFromToPlaceFromRoute()
  },

  watch: {
    eventRoutes: 'setFromToPlaceFromRoute'
  },

  computed: {
    eventRoutes: sync('odoc/model@sammanfattning'),
    stops: get('event/stops'),

    disableAddButton() {
      return this.from_place === null || this.to_place === null
    }
  },

  methods: {
    setFromToPlaceFromRoute() {
      if (this.eventRoutes && this.eventRoutes.length) {
        const route = this.eventRoutes[0].split('-')
        this.from_place = route[0].toUpperCase()
        this.to_place = route[1].toUpperCase()
      }
    },

    goBackToRouteStartPlace() {
      this.addRoute()
      this.$nextTick(() => this.$refs.routeStartPlace.focus())
    },

    goToRouteBtn() {
      this.$nextTick(() => this.$refs.routeEndPlace.blur())
      this.$nextTick(() => this.$refs.routeAddBtn.$el.focus())
    },

    addRoute() {
      const route = `${this.from_place}-${this.to_place}`
      const routes = [...this.eventRoutes, route]
      this.$store.set('odoc/model@sammanfattning', routes)

      this.from_place = null
      this.to_place = null
    },

    removeRoute(route) {
      const index = this.eventRoutes.findIndex(x => x === route)
      if (index >= 0) this.eventRoutes.splice(index, 1)
      this.$store.set('odoc/model@sammanfattning', this.eventRoutes)
    }
  }
}
</script>
